<template>
	<div class="st-main-content">
		<div></div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="vehicleList" 
				:loading="false"
				:showPage="false"
				:bottomHandleArr="bottomHandleArr"
				>
			</common-table>
		</div>
		<st-dialog title="计价规则编辑"  :toggleStDialog="toggleStDialog" @closeDialog="closeDialogForm" @saveDialog="saveDialogForm" :setScrollTop="true">
			<div class="st-dialog-content" id="st-dialog-content">
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title"><i>*</i>司机-每公里费用：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.driverPerKilometerFee" @input="numberInput($event,'vehicleForm','driverPerKilometerFee',2)"></div>
					</li>
					<li style="width: 156px;">
						<div class="st-dialog-item-title"><i>*</i>选择城市</div>
						<div class="st-dialog-item-input">
							<el-cascader class="ssqRules"  :options="options" v-model="selectedOptions"
								expand-trigger="hover"
								@change="handleChange"
								@active-item-change="handleItemChange"
								>
							</el-cascader>
						</div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>司机-起步价：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.driverStartFee" @input="numberInput($event,'vehicleForm','driverStartFee',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>司机-起步公里：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.driverStartKilometer" @input="numberInput($event,'vehicleForm','driverStartKilometer',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>车型：</div>
						<span class="order-query-form-input">
							<el-select v-model="vehicleForm.model" placeholder="请选择" class="stSetSelect" >
								<el-option
								v-for="item in modelList"
								:key="item"
								:label="item"
								:value="item">
								</el-option>
							</el-select>
						</span>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>货主-每公里费用：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.ownerPerKilometerFee" @input="numberInput($event,'vehicleForm','ownerPerKilometerFee',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>货主-起步价：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.ownerStartFee" @input="numberInput($event,'vehicleForm','ownerStartFee',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>货主-起步公里：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.ownerStartKilometer" @input="numberInput($event,'vehicleForm','ownerStartKilometer',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">拍照回单费用：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.receiptFee" @input="numberInput($event,'vehicleForm','receiptFee',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">搬运费用：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.carryFee" @input="numberInput($event,'vehicleForm','carryFee',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">尾板费用：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.liftGateFee" @input="numberInput($event,'vehicleForm','liftGateFee',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">返程费用：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.returnFee" @input="numberInput($event,'vehicleForm','returnFee',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">工具费用：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.toolFee" @input="numberInput($event,'vehicleForm','toolFee',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">长度(米)：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.length" @input="numberInput($event,'vehicleForm','length',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">宽度(米)：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.width" @input="numberInput($event,'vehicleForm','width',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">高度(米)：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.height" @input="numberInput($event,'vehicleForm','height',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">载重(吨)：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.payloadWeight" @input="numberInput($event,'vehicleForm','payloadWeight',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">体积(立方米)：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.payloadVolume" @input="numberInput($event,'vehicleForm','payloadVolume',2)"></div>
					</li>
				</ul>
			</div>
		</st-dialog>
	</div>
</template>
<script>
import stDialog from '../../components/StDialog'
import { onlycityJson, CodeToText } from '@/assets/common/city.js'
export default {
	name: 'DriverDenominatedRules',
	components: {stDialog},
	data(){
		return{
			tableColumns:[
				{
					key: '',
					title: '操作',
					align:'center',
					operate:true,
					setBtns:(row,index)=>{
						return [
							{
								label:'设置',
								style:"color:#32BB57;marginRight:30px",
								handler: (row,index) => this.setRole(row)
							},
							{
								label:'删除',
								handler: (row,index) => this.delRole(row.id)
							}
						]
					}
				},
				{
					key:'driverStartFee',
					title:'司机起步价',
					align:'center',
					width:'100'
				},{
					key:'driverStartKilometer',
					title:'司机起步公里',
					align:'center',
					width:'100'
				},{
					key:'driverPerKilometerFee',
					title:'司机公里/费用',
					align:'center',
					width:'120'
				},{
					key:'model',
					title:'车型',
					align:'center',
					width:'100'
				},{
					key:'liftGateFee',
					title:'尾板费用',
					align:'center',
					width:'100'
				},{
					key:'ownerStartFee',
					title:'货主起步价',
					align:'center',
				},{
					key:'ownerStartKilometer',
					title:'货主起步公里',
					align:'center',
				},{
					key:'ownerPerKilometerFee',
					title:'货主公里/费用',
					align:'center',
				},{
					key:'receiptFee',
					title:'拍照回单费用',
					align:'center',
				},{
					key:'carryFee',
					title:'搬运费用',
					align:'center',
				},{
					key:'cityName',
					title:'城市',
					align:'center',
				}
			],
			bottomHandleArr: [
				{
					label: '新增',
					handler: () => this.addRole()
				}
			],
			options: onlycityJson,
			selectedOptions: [],
			toggleStDialog:false,//控制弹窗
			vehicleList:[],//
			vehicleId:null,
			vehicleForm:{
				driverPerKilometerFee:"", //		司机-每公里费用	number	必填
				driverStartFee:"", //	司机-起步价	number	必填
				driverStartKilometer:"", //司机-起步公里	number	必填
				ownerPerKilometerFee:"", //	货主-每公里费用	number	必填
				ownerStartFee:'', //	货主-起步价	number	必填
				ownerStartKilometer	:'', //货主-起步公里	number	必填
				model:'', //	车型	string	必填

				carryFee:"", //	搬运费用	number	
				receiptFee:"", //	拍照回单费用	number	
				returnFee:"", //	返程费用	number	
				toolFee:"", //	工具费用	number	
				provinceCode:"", // 省代号
				provinceName:"", // 省名称
				cityCode:"", // 市代号
				cityName:"", // 市名称
			},
			checkFrom:{
				driverPerKilometerFee:'请填写 司机-每公里费用',
				driverStartFee:"请填写 司机-起步价", 
				driverStartKilometer:"请填写 司机-起步公里", 
				ownerPerKilometerFee:"请填写 货主-每公里费用", 
				ownerStartFee:'请填写 货主-起步价', 
				ownerStartKilometer	:'请填写 货主-起步公里', 
				model:'请选择 车型',
				provinceCode:'请选择城市'
			},
			modelList:[],
		}
	},
	created() {

	},
	methods:{
		// 设置
		setRole(item){
			this.toggleStDialog=true;
			this.vehicleId=item.id;
			this.vehicleForm=item;
			this.selectedOptions=[item.provinceCode,item.cityCode]
		},
		delRole(id) {
			this.$toast.stConfirm('是否确认删除?', res => {
				if (res) {
					this.$server.system.delVehicle(id, res => {
						this.$message({
							message: '操作成功',
							center: true
						});
						this.vehicleListInfo();
					})
				}
			})
		},
		vehicleListInfo(){
			this.$server.system.vehicleList(res=>{
				this.vehicleList=res.data;
			})
		},
		addRole(){
			this.toggleStDialog=true;
			this.vehicleForm={};
			this.selectedOptions=[]
		},
		closeDialogForm(){
			this.toggleStDialog=false;
			this.vehicleListInfo()
		},
		saveDialogForm(){

			for(var key in this.checkFrom){
				if(!this.vehicleForm[key]){
					return	this.$message({
						message:  this.checkFrom[key],
						center: true,
						type: 'warning'
					});
				}
			}
			let data=this.vehicleForm;
			data.id=this.vehicleForm.id;
			let requestMethod = 'setVehicle'

			if (!data.id) {
				requestMethod = 'addVehicle'
			}
			this.$server.system[requestMethod](data,(res)=>{
				if(res.code==0){
					this.$message({
						message: '操作成功',
						center: true
					});
					this.vehicleListInfo();
				}else{
					this.$message({
						message: res.message,
						center: true
					});
				}
			})
			this.toggleStDialog=false;
		},
		handleChange(value) {
			// 省市区选择
			const [provinceName, cityName] = [CodeToText[value[0]], CodeToText[value[1]]]
			this.vehicleForm.provinceName = provinceName
			this.vehicleForm.cityName = cityName
			this.vehicleForm.provinceCode = value[0]
			this.vehicleForm.cityCode = value[1]
		},
		handleItemChange(val){
			this.options.forEach((childrenItem) => {
				childrenItem.children.forEach(item=>{
					item.children=null
				})
			});
		},
		getCars(){
			this.$server.system.getAllCar({},res=>{
				this.vehicleForm.model=res.data[0]
				this.modelList=res.data
			})
		},
		numberInput(e,obj,attr,n){
			var inputValue=e.target.value;
			inputValue=this.$util.numDotCovt(inputValue,n);
			this[obj][attr]=inputValue 
		},
		
	},
	mounted() {
		this.getCars()
		this.vehicleListInfo();
	}
}

</script>
<style>
.driver-denominated-rules {
  width: 100%;
  height: auto;
}
.data-table-box {
    height: auto;
    background: #FFF;
    padding: 8px;
    box-sizing: border-box;
}	
.data-table{
	margin-bottom: 8px;
	text-align: center;
}
.query-setting-box-left{
    flex-grow: 0;
}
.setRole{
	display: inline-block;
	width: 60px;
	height: 32px;
	line-height: 32px;
	color: #32BB57;
	margin-left: 40px;
	margin-right: 20px;
	cursor: pointer;
	text-align: center;
}
.delRole{
	display: inline-block;
	width: 60px;
	height: 32px;
	line-height: 32px;
	color: #FF5B3E;
	cursor: pointer;
	text-align: center;
}
/*  */
.st-dialog-content{
	padding: 0 32px;
}
.st-dialog-form{
	width: 406px;
}
.st-dialog-form li {
	width: 156px;
	padding: 13px 0;
}
.st-dialog-form li:nth-child(even){
	float: right;
}
.st-dialog-form li:nth-child(odd){
	float: left;
}
.st-dialog-form .st-dialog-item-title{
	height: 20px;
	line-height: 20px;
}
.st-dialog-form .st-dialog-item-title i{
	color: #FF5B3E;
}
.st-dialog-form .st-dialog-item-input input{ 
	width: 156px;
	height: 30px;
	text-indent: 8px;
	border-radius: 2px;
	border: 1px solid #DCDCDC;
	box-sizing: border-box;
}
.ssqRules{
	width: 156px;
}
.ssqRules /deep/.el-input__inner {
	padding-left: 0;
}
</style>
